module.exports = __webpack_public_path__ + "static/media/inf_51og60.6b4e69b7.mp3";